import React from 'react';
import styles from './separator.module.css';

export function Separator({ marginSize = '' }) {
  return <div className={`${styles.line} ${styles[marginSize] || styles['space24']}`} />;
}
